import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import getElementUI from './plugins'
import permissionDirective from './utils/permission'
import permissionDisableDirective from './utils/permission/show'

import 'amfe-flexible'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'

Vue.config.productionTip = false
Vue.use(getElementUI)
Vue.use(permissionDirective)
Vue.use(permissionDisableDirective)


new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
